/**
 * @ppwr/poker-engine
 * Pure TypeScript poker engine for Texas Hold'em
 */

// Main engine
export { PokerEngine } from './engine'
export type { BlindPolicy } from './engine'

// Types
export type {
  Card,
  ActionType,
  BoardState,
  PlayerState,
  PlayerPosition,
  GameConfig,
  EnginePlayer,
  GameState,
  GameFlowStateType,
  ActionResult,
  ValidationResult,
  Winner,
  PlayerAction,
  // Sidepot types
  Pot,
  PotStructure,
  PotDistribution,
  PotWinner,
  HandOutcome,
  // Deprecated types (for migration)
  LegacyPotStructure
} from './types'

// Utilities (for advanced usage)
export { createDeck, shuffle, dealCards } from './deck'
// Evaluation utilities (findWinners is exported for testing, prefer PokerEngine.completeHand())
export { evaluateHand, compareHands, findWinners, findWinnersForPot } from './evaluator'
export { getAvailableActions, validateAction } from './validation'
export {
  getGameStateFlow,
  // isRoundComplete,
  // isHandComplete,
  getNextActivePlayer,
  getFirstPlayerToAct
} from './progression'
// Sidepot utilities (for advanced usage - PokerEngine handles this automatically)
export {
  // Core functions
  calculateSidepots,
  mergePotStructures,
  distributePots,
  extractUncalledBets,
  // Helper functions
  getAllPots,
  getMainPot,
  getSidePots,
  getCumulativeContributions,
  getPlayerTotalContribution,
  hasSidePots,
  getPotCount,
  createEmptyPotStructure,
  // Query functions
  getEligiblePlayers,
  getTotalPotAmount,
  // Formatting functions
  formatPotStructure,
  formatPotStructureDetailed,
  // Migration helpers (deprecated - for backward compatibility only)
  fromLegacyPotStructure,
  toLegacyPotStructure
} from './sidepot'
